import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamNames } from 'src/app/core/constantes/http_param-names';
import { Contact } from '../../models/server/contact';
import { Context } from '../../models/server/core/context';
import { FilterInfos } from '../../models/server/core/filter-infos';
import { Results } from '../../models/server/core/results-T';
import { SortInfos } from '../../models/server/core/sort-infos';
import { AdvancedService } from '../core/advanced.service';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class ContactsService extends ServiceBase implements AdvancedService<Contact> {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste les contacts.
     * @param context : Context
     * @param filters : Information pour le filtre
     * @param sortInfos : Information pour le tri
     * @param pageNumber : Numéro de la page
     * @param pageSize : Nombre d'élément sur la page
     * @returns Liste de contacts
     */
    public List(context: Context, filters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<Contact>> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(sortInfos),
                filters: this.getHeader(filters),
                context: this.getHeader(context),
            }),
            params: new HttpParams().set(HttpParamNames.FROM, pageNumber.toString()).set(HttpParamNames.SIZE, pageSize.toString()),
        };

        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/Contacts`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<Contact>(Contact, x);
                return res;
            })
        );
    }

    /**
     * Ajoute un contact
     * @param contact : Information du contact
     */
    public add(contact: Contact): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http.post(this.baseUrl + `/api/organizations/${this.organizationId}/contacts`, contact, httpOptions).pipe(
            map((x) => {
                return true;
            })
        );
    }
}
